import { dataTypeSymbol } from "../../../logged-in/shared/functions/Scorecard";
import { dateFormat } from "../../../logged-in/shared/utils/utils";
import { fullPerspectiveName } from "../../interfaces/IPerspectiveTabs";
import { IMeasureCompany } from "../../models/MeasureCompany";
import { IObjective } from "../../models/Objective";
import { dataFormat } from "../Directives";
import { marginTopBottom, header, sectionHeader } from "./DocDefition";
import { brandLogo, footerStripes } from "./ImageDefinition";

const tableWidths: Row = [
  100,
  "*",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  //
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
];

const tableHeader: Row = [
  { text: "Perspective", style: "tableHeader" },
  { text: "Strategic Objectives", style: "tableHeader" },
  { text: "Weight (%)", style: "tableHeader" },
  { text: "Measures/KPI", style: "tableHeader" },
  { text: "Baseline", style: "tableHeader" },
  { text: "Quarterly Target , Q1", style: "tableHeader" },
  { text: "Quarterly Target , Q2", style: "tableHeader" },
  { text: "Quarterly Target , Q3", style: "tableHeader" },
  { text: "Quarterly Target , Q4", style: "tableHeader" },
  { text: "Annual Target", style: "tableHeader" },
  { text: "Rating Scale 1-5", style: "tableHeader" },
  { text: "Key Initiatives", style: "tableHeader" },
  { text: "Target Date", style: "tableHeader" },
  { text: "Source of Evidence", style: "tableHeader" },
  { text: "Comments", style: "tableHeader" },
  //
  { text: "Midterm E Rating", style: "tableHeader" },
  { text: "Midterm S Rating", style: "tableHeader" },
  { text: "Midterm F Rating", style: "tableHeader" },
  { text: "Assessment E Rating", style: "tableHeader" },
  { text: "Assessment S Rating", style: "tableHeader" },
  { text: "Assessment F Rating", style: "tableHeader" },
];

type RowSpan = {
  text: string | any;
  rowSpan?: number;
  style?: string;
};

type Row = [
  string | number | RowSpan, //   "Perspective",
  string | RowSpan, //   "Strategic Objectives",
  string | number | RowSpan, //   "Weight (%)",
  string | number | RowSpan, //   "Measures/KPI",
  string | number | RowSpan, //   "Baseline",
  string | number | RowSpan, //   "Quarterly Target , Q1",
  string | number | RowSpan, //   "Quarterly Target , Q2",
  string | number | RowSpan, //   "Quarterly Target , Q3",
  string | number | RowSpan, //   "Quarterly Target , Q4",
  string | number | RowSpan, //   "Annual Target",
  string | RowSpan, // Rating scale 1-5
  string | number | RowSpan, //   "Key Initiatives",
  string | number | RowSpan, //   "Target Date",
  string | RowSpan, //   "Source of Evidence",
  string | RowSpan, //   "Comments",
  //
  string | number | RowSpan, //   "E",
  string | number | RowSpan, //   "S",
  string | number | RowSpan, //   "F",
  string | number | RowSpan, //   "E",
  string | number | RowSpan, //   "S",
  string | number | RowSpan //   "F",
];

export interface ICompanyAgreementTableRowItem {
  perspective: string; // "Perspective"
  objectiveId: string;
  description: string; // "Strategic Objectives"
  weight: number; // "Weight (%)"
  measure: string | number; // "Measures/KPI"
  baseline: string | number; // "Baseline"
  q1target: string | number; // "Quarterly Target , Q1"
  q2target: string | number; // "Quarterly Target , Q2"
  q3target: string | number; // "Quarterly Target , Q3"
  q4target: string | number; // "Quarterly Target , Q4"
  annualTarget: string | number; // "Annual Target"
  ratingScale: string; // "Annual Target",
  keyInitiatives: string | number; // "Key Initiatives"
  targetDate: string | number; // "Target Date"
  sourceOfEvidence: string; // "Source of Evidence"
  comments: string; // "Comments"
  dataType?: string; // "Data type"
  dataSymbol?: string; // "Symbol"
  //
  rating: number |null; //q1 auto rating
  q2supervisorRating: number | null; //
  q2FinalRating: number | null; //
  q4rating: number |null; //q2 auto rating
  q4supervisorRating: number | null; //
  q4FinalRating: number | null; //
}

export const formatObjectiveWeight = (weight: number | null | undefined) =>
  `${Number.isFinite(Number(weight)) ? Number(weight) : 0}%`;

const sortByPerspective = (
  a: ICompanyAgreementTableRowItem,
  b: ICompanyAgreementTableRowItem
) => {
  const perspectiveOrder = [
    "Financial",
    "Stakeholder",
    "Operational Excellence",
    "Human Capital",
  ];
  // First sort by perspective
  let aIndex = perspectiveOrder.indexOf(a.perspective);
  let bIndex = perspectiveOrder.indexOf(b.perspective);

  // Default to string comparison if not found in perspective order
  if (aIndex === -1 || bIndex === -1)
    return a.perspective.localeCompare(b.perspective);

  // Order by objective if same perspective.
  if (aIndex === bIndex) return a.objectiveId.localeCompare(b.objectiveId);

  return aIndex - bIndex;
};

export const ConvertToTableRowItem = (
  objectives: IObjective[],
  measures: IMeasureCompany[]
): ICompanyAgreementTableRowItem[] => {
  const formatMeasureValue = (type: string, value: string | number | null) => {
    const suffix = dataTypeSymbol(type).suffix;
    const prefix = dataTypeSymbol(type).prefix;

    if (!value) return "";
    if (type === "Date") return dateFormat(Number(value));
    if (type === "Currency")
      return `${prefix}${Number(value).toFixed(2)}${suffix}`;

    return `${prefix}${value}${suffix}`;
  };

  const rowForObjective = (
    strategic: IObjective | undefined,
    measure?: IMeasureCompany
  ): ICompanyAgreementTableRowItem => {
    const ratingScale = () => {
      if (!measure) return "-";
      const r1 =
        measure.rating1 !== 0
          ? `1 = ${dataFormat(measure.dataType, measure.rating1, measure.dataSymbol)}`
          : `1 = 0`;
      const r2 =
        measure.rating2 !== 0
          ? `2 = ${dataFormat(measure.dataType, measure.rating2, measure.dataSymbol)}`
          : `2 = 0`;
      const r3 =
        measure.rating3 !== 0
          ? `3 = ${dataFormat(measure.dataType, measure.rating3, measure.dataSymbol)}`
          : `3 = 0`;
      const r4 =
        measure.rating4 !== 0
          ? `4 = ${dataFormat(measure.dataType, measure.rating4, measure.dataSymbol)}`
          : `4 = 0`;
      const r5 =
        measure.rating5 !== 0
          ? `5 = ${dataFormat(measure.dataType, measure.rating5, measure.dataSymbol)}`
          : `5 = 0`;

      return `${r1}\n${r2}\n${r3}\n${r4}\n${r5}`;
    };

    return {
      perspective: fullPerspectiveName(strategic?.perspective ?? ""),
      objectiveId: strategic?.id ?? "unknown",
      description: strategic ? strategic.description : "unknown",
      weight: strategic ? strategic.weight ?? 0 : 0,
      measure: measure?.description || "-",
      baseline: measure ? formatMeasureValue(measure.dataType, measure.baseline) : "-",
      q1target: measure ? formatMeasureValue(measure.dataType, measure.quarter1Target) : "-",
      q2target: measure ? formatMeasureValue(measure.dataType, measure.quarter2Target) : "-",
      q3target: measure ? formatMeasureValue(measure.dataType, measure.quarter3Target) : "-",
      q4target: measure ? formatMeasureValue(measure.dataType, measure.quarter4Target) : "-",
      annualTarget: measure ? formatMeasureValue(measure.dataType, measure.annualTarget) : "-",
      ratingScale: ratingScale(),
      keyInitiatives: measure?.activities || "-",
      targetDate: measure?.targetDate || "-",
      sourceOfEvidence: measure?.sourceOfEvidence || "-",
      comments: measure?.comments || "-",
      dataType: measure?.dataType,
      dataSymbol: measure?.dataSymbol,
      rating: measure?.rating ?? null,
      q2supervisorRating: measure?.q2supervisorRating ?? null,
      q2FinalRating: measure?.q2FinalRating ?? null,
      q4rating: measure?.q4rating ?? null,
      q4supervisorRating: measure?.q4supervisorRating ?? null,
      q4FinalRating: measure?.q4FinalRating ?? null,
    };
  };

  // Build the export from objectives first so an objective and its weight are
  // never omitted simply because it has no KPI rows yet.
  const objectiveRows = objectives.flatMap((objective) => {
    const objectiveMeasures = measures.filter(
      (measure) => measure.objective === objective.id
    );

    return objectiveMeasures.length
      ? objectiveMeasures.map((measure) => rowForObjective(objective, measure))
      : [rowForObjective(objective)];
  });

  // Preserve orphaned KPI rows for data visibility, even if their objective
  // was removed or is unavailable in the current in-memory collection.
  const orphanRows = measures
    .filter(
      (measure) => !objectives.some((objective) => objective.id === measure.objective)
    )
    .map((measure) => rowForObjective(undefined, measure));

  return [...objectiveRows, ...orphanRows].sort(sortByPerspective);
};

const FormatTableSpan = (_rows: ICompanyAgreementTableRowItem[]) => {
  let perspective = "";
  let objectiveId = "";

  const rows: Row[] = _rows.map((row, _, data) => {
    let perspectiveRowSpan = undefined;
    let objectiveRowSpan = undefined;

    if (perspective !== row.perspective) {
      perspective = row.perspective;
      perspectiveRowSpan = data.filter(
        (r) => r.perspective === perspective
      ).length;
    }

    if (objectiveId !== row.objectiveId) {
      objectiveId = row.objectiveId;
      objectiveRowSpan = data.filter(
        (r) => r.objectiveId === objectiveId
      ).length;
    }

    return [
      {
        rowSpan: perspectiveRowSpan ?? 1,
        text: row.perspective,
      },
      {
        rowSpan: objectiveRowSpan ?? 1,
        text: row.description,
      },
      {
        rowSpan: objectiveRowSpan ?? 1,
        text: formatObjectiveWeight(row.weight),
      },
      row.measure ?? "-", // "Measures/KPI"
      row.baseline ?? "-", // "Baseline",
      row.q1target ?? "-", // "Quarterly Target , Q1"
      row.q2target ?? "-", // "Quarterly Target , Q2"
      row.q3target ?? "-", // "Quarterly Target , Q3"
      row.q4target ?? "-", // "Quarterly Target , Q4"
      row.annualTarget ?? "-", // "Annual Target"
      row.ratingScale, // rating scale 1-5
      row.keyInitiatives ?? "-", // "Key Initiatives"
      row.targetDate ?? "", // "Target Date"
      row.sourceOfEvidence ?? "", // "Source of Evidence"
      row.comments ?? "", // "Comments"
      row.rating ?? 0,
      row.q2supervisorRating ?? 0,
      row.q2FinalRating ?? 0,
      row.q4rating ?? 0,
      row.q4supervisorRating ?? 0,
      row.q4FinalRating ?? 0,
    ];
  });

  return rows;
};

export const CompanyPerformanceAgreementDocument = async (
  title: string,
  objectives: IObjective[],
  measures: IMeasureCompany[]
) => {
  const logo = await brandLogo();
  const footer = await footerStripes();

  // Group measures under each corresponding objective and sort them.
  const rows: ICompanyAgreementTableRowItem[] = ConvertToTableRowItem(
    objectives,
    measures
  );

  // Calculate column span perspectives and objectives accordingly.
  const mappedRows = FormatTableSpan(rows);
  
  // Add to table structure for pdf gen.
  const body = [tableHeader, ...mappedRows];

  return {
    pageSize: "A2", // by default we use portrait, you can change it to landscape if you wish
    pageOrientation: "landscape",
    footer,
    content: [
      logo,
      marginTopBottom(),
      header(title),
      marginTopBottom(),
      sectionHeader("To be the leading electricity regulator in Africa."),
      marginTopBottom(),
      sectionHeader("Vision:"),
      sectionHeader(
        "To regulate the Namibian Electricity Supply Industry in a sustainable manner, in the interest of all stakeholders with regard to efficiency, affordability, safety and accessibility."
      ),
      marginTopBottom(),

      {
        logo,
        table: {
          headerRows: 1,
          widths: tableWidths,
          body: body,
        },
      },
      marginTopBottom(),
      marginTopBottom(),
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: "black",
      },
    },
  };
};
